import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createTransfer: [],
  loading: false,
  error: null,
};

const createTransferSlice = createSlice({
  name: "createTransfer",
  initialState,
  reducers: {
    fetchCreateTransferRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCreateTransferSuccess: (state, action) => {
      state.loading = false;
      state.createTransfer = action.payload;
    },

    fetchCreateTransferFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCreateTransferRequest,
  fetchCreateTransferSuccess,
  fetchCreateTransferFailure,
} = createTransferSlice.actions;

export default createTransferSlice.reducer;